import React from 'react';
import { Provider } from 'models';
import SaveProviderButton from './iconActions/SaveProviderButton';
import MessageProviderAction from './iconActions/MessageProviderAction';

export default function ProviderCardMobileIconActions({ provider }: { provider: Provider }) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'flex-end',
                flexGrow: 1,
                padding: 15,
            }}
        >
            <SaveProviderButton provider={provider} />
            <div style={{ width: 4 }} />
            <MessageProviderAction location="ProviderCard" provider={provider} />
        </div>
    );
}
